import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  lng: navigator?.language?.substr(0, 2) || /* istanbul ignore next */ 'en',
  resources: {
    en: {
      translation: {
        'A - Z': 'A - Z',
        'Agent Directory': 'Agent Directory',
        'Agent Search': 'Agent Search',
        agents: 'agents',
        'Ask a question': 'Ask a question',
        'Are you currently working with an agent': 'Are you currently working with an agent?',
        'Areas Served': 'Areas Served',
        'Best Match': 'Best Match',
        buy: 'buy',
        sort: 'sort',
        'Buy or Sell a home': 'Buy or Sell a home',
        'Check for typos or misspelled words': 'Check for typos or misspelled words',
        Contact: 'Contact',
        'Contact Info': 'Contact Info',
        'Contact Preference': 'Contact Preference',
        "Don't give up! We know we can find an eXp agent that will meet your needs!": "Don't give up! We know we can find an eXp agent that will meet your needs!",
        Email: 'Email',
        EmailInvalid: 'Must be a valid email',
        'eXp Agents': 'eXp Agents',
        'eXp Managing Brokers': 'eXp Managing Brokers',
        Featured: 'Featured',
        'First Name': 'First Name',
        FirstNameRequired: 'First name is required',
        Home: 'Home',
        "I'm looking to": `I'm looking to`,
        'Join eXp Realty': 'Join eXp Realty',
        'Last Name': 'Last Name',
        LastNameRequired: 'Last name is required',
        Location: 'Location',
        'Max. 5000 characters': 'Max. 5000 characters',
        Message: 'Message',
        MessageRequired: 'Message is required',
        Mobile: 'Mobile',
        'Mobile Phone': 'Mobile Phone',
        Name: 'Name',
        Call: 'Call',
        No: 'No',
        'No Preference': 'No Preference',
        PhoneNumberInvalid: 'Must be a valid phone number',
        Province: 'Province',
        'Real Estate Agent': 'Real Estate Agent',
        'Refer a client': 'Refer a client',
        required: 'required',
        'Return to Search': 'Return to Search',
        Search: 'Search',
        'Search Agents': 'Search Agents',
        'Search Managing Brokers': 'Search Managing Brokers',
        sell: 'sell',
        'sign in': 'sign in',
        'sign up': 'sign up',
        State: 'State',
        Submit: 'Submit',
        Submitting: 'Submitting',
        'Text/SMS': 'Text/SMS',
        'Try a different search term': 'Try a different search term',
        "We couldn't find any matches for your search.": "We couldn't find any matches for your search.",
        Work: 'Work',
        Yes: 'Yes',
        'Z - A': 'Z - A',
      },
    },
  },
});

export default i18n;
